import type { ReactElement } from 'react';
import React, { useCallback } from 'react';
import IconButton from 'atom-components/buttons/icon-button';

/**
 * A Standard print button
 * - styled the same across the site
 * - won't be visible in the printed document
 * - uses `window.print()`
 *
 */
export default function PrintButton(): ReactElement {
  const printReport = useCallback(() => {
    window.print();
  }, []);

  return (
    <IconButton icon="print" outline className="d-print-none" text="Print" onClick={printReport} />
  );
}
